import { useState } from "react";

import { FaEye, FaFlag } from "react-icons/fa";

import BasicDataTable from "../../Component/BasicComponents/BasicDataTable";
import PageHeader from "../../Component/BasicComponents/HeaderBreadCrumbs";
import RoundedDropdown from "../../Component/BasicComponents/Dropdowns/RoundedDropdown";
import {
  useGetEmployeeLsit,
  useGetEmployeeVisit,
  useGetMothYearFiler,
} from "./Employee_hook/useEmployee";
import { useGetOrgUnitsData } from "../Employee/hooks/useEmployee";
import RouteModal from "../../Component/BasicComponents/Modal/RouteModal";
import { Btn } from "../../AbstractElements";
import { COLORS } from "../../constants/colors";
import { getEmployeeReport } from "./Employee_hook/EmployeeRepo";
import { useExcelPolling } from "../../hooks/useExcelPolling";
import { showToast } from "../../utils/toastUtils";
// import AnnouncementModal from "./components/AnnouncementModal";

type Props = {};

interface filterDataInterface {
  page?: number;
  limit?: number;
  search?: string;
  sortColumn?: string;
  sortOrder?: string;
  orgUnitId?: string;
  employeeId?: number;
  startDate?: number; // YY-MM-DD
  endDate?: number;
  month?: string;
}

function EmployeeReport({}: Props) {
  const{startPolling} = useExcelPolling();
  const [modal, setModal] = useState(false);
  const [AttendanceId, setAttendanceId] = useState();
  const [loadingExcel, setLoadingExcel] = useState<boolean>(false);
  const [excelStatus, setExcelStatus] = useState<string | null>("Loading.");
  

  const [filterData, setFilterData] = useState<filterDataInterface>({
    page: 1,
    limit: 10,
    search: "",
    orgUnitId: undefined,
    month: undefined,
  });

  const monthfilterFormate = () => {
    if (!filterData.month) return undefined; // prevent crash
    const [YY, mon] = String(filterData.month).split("-");

    const monthMap: Record<string, string> = {
      Jan: "01",
      Feb: "02",
      Mar: "03",
      Apr: "04",
      May: "05",
      Jun: "06",
      Jul: "07",
      Aug: "08",
      Sep: "09",
      Oct: "10",
      Nov: "11",
      Dec: "12",
    };

    return `${YY}-${monthMap[mon] || "01"}`;
  };

  const {
    data: empReportData,
    isLoading: empReportDataisLoading,
    isSuccess: empReportDataIsSuccess,
  } = useGetEmployeeLsit({
    enable: !!filterData.search || !!filterData.orgUnitId || !!filterData.month,
    param: {
      action: "view",
      page: filterData.page,
      limit: filterData.limit,
      ...(filterData.search == "" ? {} : { search: filterData.search }),
      month: monthfilterFormate(),
      ...(filterData.orgUnitId === undefined
        ? {}
        : { orgUnitId: Number(filterData.orgUnitId) }),
    },
  });

  const handleDownload = async () => {
    const param = {
      action: "download",
      page: filterData.page,
      limit: filterData.limit,
      ...(filterData.search == "" ? {} : { search: filterData.search }),
      month: monthfilterFormate(),
      ...(filterData.orgUnitId === undefined
        ? {}
        : { orgUnitId: Number(filterData.orgUnitId) }),
    };

    try {
      setLoadingExcel(true);
      const response = await getEmployeeReport(param);
       const {fileDownloadId,intervalTime,success} = response?.rowData?.data ||{}   
       if(fileDownloadId && success){
        startPolling(fileDownloadId,intervalTime,{
          onStatusUpdate:(currentStatus:string)=>{
           setExcelStatus(currentStatus);
          },
          onSuccess:(url:string)=>{
            setLoadingExcel(false);
            setExcelStatus('Loading..')
           const a = document.createElement('a');
           a.href = url;
           a.download = "report.xlsx"
           a.click();
           showToast.success('The file is ready!')
          },
          onFailed:(message:string)=>showToast.error(message||"OnFalied Error in Employee report"),
          onExpired:(message:string)=>showToast.error(message ||"OnExpired error in Employee report"),
          onDelete:(message:string)=>showToast.error(message||'OnDelete error in Employee report')
        });
      }
    } catch (error: any) {
      console.log("Error while downloading Employee excel report");
    }
  };

  const { data: orgUnitsList } = useGetOrgUnitsData({ enable: true });
  const { data: MonthYearData } = useGetMothYearFiler({ enable: true });
  const { data: employeeVisiteData } = useGetEmployeeVisit({
    enable: !!AttendanceId,
    attendanceId: Number(AttendanceId),
    // attendanceId: 506772,
  });

  // console.log('pagination',empReportData?.rowData?.data)

  const handlePagination = (pageNo: any) => {
    setFilterData((prev: any) => ({
      ...prev,
      page: pageNo,
    }));
  };
  const handleonChangeRowsPerPage = (limit: any, page: any) => {
    setFilterData((prev: any) => ({
      ...prev,
      page: page,
      limit: limit,
    }));
  };

  const handleSearch = (serach: any) => {
    setFilterData((prev: any) => ({
      ...prev,
      search: serach,
    }));
  };

  const handleFilter = (key: any, value: any) => {
    setFilterData((prev: any) => ({
      ...prev,
      [key]: value.id,
    }));
  };

  // console.log('filterData',orgUnitsList?.data);

  const handleReportView = (row: any) => {
    setAttendanceId(row.AttendanceId);
    setModal(true);
  };

  const toggleModl = () => {
    setModal(!modal);
  };

  const employeeReportsColumn = [
    {
      name: "Sr.",
      selector: (row: { EmployeeCode: string }) =>
        row.EmployeeCode ? row.EmployeeCode : "-",
      sortable: true,
    },
    {
      name: "Employee Name",
      selector: (row: { FullName: string }) => row.FullName ?? "-",
      sortable: true,
      width: "180px",
      wrap: true,
    },
    {
      name: "Start Time",
      selector: (row: { StartTime: string }) => row.StartTime ?? "-",
      sortable: true,
      width: "180px",
    },
    {
      name: "End Time",
      selector: (row: { endtime: string }) => row.endtime || "-",
      sortable: true,
      width: "180px",
    },
    {
      name: "Outlet Count",
      selector: (row: { OutletCount: string | number }) =>
        row.OutletCount === 0 ? "0" : row.OutletCount || "-",
      sortable: true,
      width: "180px",
    },
    {
      name: "Attendance Date",
      selector: (row: { AttendanceDate: string }) => row.AttendanceDate || "-",
      sortable: true,
      width: "200px",
    },
    {
      name: "Status",
      selector: (row: { Status: string | number }) => row.Status || "-",
      sortable: true,
    },
    {
      name: "Action",
      width: "120px",
      cell: (row: any) => (
        <div>
          <button
            onClick={() => handleReportView(row)}
            className="btn btn-primary d-flex align-items-center justify-content-center"
            style={{ borderRadius: "20px", padding: "3px", width: "70px" }}
          >
            <FaEye style={{ fill: "#fff" }} size={20} /> View
          </button>
        </div>
      ),
    },
  ];

  const employee_Visited_ReportsColumn = [
    {
      name: "Outlet Name",
      selector: (row: { OutletName: string }) => row.OutletName ?? "-",
      sortable: true,
      // width: "180px",
    },
    {
      name: "Outlet Code",
      selector: (row: { OutletCode: string }) => row.OutletCode ?? "-",
      sortable: true,
      // width: "180px",
    },
    {
      name: "Town Name",
      selector: (row: { TownName: string }) =>
        row.TownName ? row.TownName : "-",
      sortable: true,
    },
  ];

  return (
    <div className="p-2">
      <PageHeader
        title="Employee Report"
        buttons={[
          {
            label: loadingExcel
              ? excelStatus
                ? excelStatus.charAt(0).toUpperCase() +
                  excelStatus.slice(1) +
                  ".."
                : ""
              : "Excel",
            onClick: () => handleDownload(),
            color: loadingExcel ? COLORS.disable : COLORS.primary,
            disable: loadingExcel ? true : false,
          },
        ]}
      />

      {/* Table with Filters */}
      <BasicDataTable
        Title="Employee Report"
        filterFirstApporach={
          !!filterData.search || !!filterData.orgUnitId || !!filterData.month
        }
        data={
          empReportData?.formatedData.length > 0
            ? empReportData?.formatedData
            : []
        }
        columns={employeeReportsColumn}
        noDataText={"No Data ! Please,Select any filter First!"}
        showSpinner={empReportDataisLoading}
        headerContent={
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              gap: "10px",
              marginBottom: "15px",
              marginRight: "8px",
            }}
          >
            {/* Month Dropdown */}
            <RoundedDropdown
              options={MonthYearData?.formatedData || []}
              onSelect={(e) => handleFilter("month", e)}
              defaultLabel="All"
              width="120px"
              isShowHeading
              DropdownHeading="Month"
              headingColor="#2e8dd3"
            />
            <RoundedDropdown
              options={orgUnitsList?.data || []}
              onSelect={(e) => handleFilter("orgUnitId", e)}
              defaultLabel="All"
              width="120px"
              isShowHeading
              DropdownHeading="Division"
              headingColor="#2e8dd3"
            />
          </div>
        }
        onChangePage={(pageNo: number) => {
          handlePagination(pageNo);
        }}
        onChangeRowsPerPage={(newPerPage: any, page: any) => {
          handleonChangeRowsPerPage(newPerPage, page);
        }}
        handleSearch={(val: any) => {
          handleSearch(val);
        }}
        paginationTotalRows={
          empReportData?.rowData?.data?.Pagination.TotalCounts || 0
        }
      />
      <RouteModal
        isOpen={modal}
        toggle={toggleModl}
        title="Overview of Outlets Visited"
        size="lg"
        content={
          <div className="mt-3">
            <div style={{ display: "flex", gap: "14px" }}>
              <FaFlag color="red" title="Start Flag" size={20} />
              <strong>
                Start Town: {employeeVisiteData?.rowData.data.StartTown || "-"}
              </strong>
              <strong>
                Start Time:{employeeVisiteData?.rowData.data.StartTime || "-"}
              </strong>
              <strong>
                End Time: {employeeVisiteData?.rowData.data.EndTime || "-"}
              </strong>
            </div>

            <BasicDataTable
              search={false}
              Title=""
              columns={employee_Visited_ReportsColumn || []}
              data={employeeVisiteData?.rowData.data.Outlets || []}
            />
            <div style={{ display: "flex", gap: "14px" }}>
              <FaFlag color="green" size={20} title="End Flag" />
              <strong>
                End Town: {employeeVisiteData?.rowData.data.EndTown || "-"}
              </strong>
              <strong>
                Total Distance:{" "}
                {employeeVisiteData?.rowData.data.Distance || "-"}
              </strong>
              <strong>
                {" "}
                | Total Time: {employeeVisiteData?.rowData.data.Duration || "-"}
              </strong>
            </div>

            <div className="d-flex justify-content-start mt-3 gap-2 flex-wrap">
              <Btn
                style={{
                  backgroundColor: "#F9FAFC",
                  color: "#000",
                  border: "1px solid #E0E0E0",
                }}
                type="button"
                onClick={() => setModal(false)}
              >
                Cancel
              </Btn>
            </div>
          </div>
        }
      />
    </div>
  );
}

export default EmployeeReport;
